import { CHANGE_NETWORK } from '../mutation-types'

const state = {
  network: true
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  [CHANGE_NETWORK] (state, networkstate) {
    state.network = networkstate
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
